import { defineStore } from "pinia";

export const useErrorStore = defineStore({
  id: "errorStore",
  state: () => ({
    errorMessage: "",
    errorTimestamp: null,
  }),
  actions: {
    setErrorMessage(message) {
      this.errorMessage = message;
      this.errorTimestamp = new Date().getTime(); // Update timestamp
    },
    clearErrorMessage() {
      this.errorMessage = null;
      this.errorTimestamp = null;
    },
  },
  getters: {
    isError: (state) => {
      return !!state.errorMessage;
    },
  },
});
